import React, {useEffect, useState} from "react"
import DropZone from "react-dropzone"

function DropZoneField(props) {

    const [imageFile, setImageFile] = useState();
    const {field, form} = props;

    useEffect(() => () => {
        if (imageFile?.preview) {
            URL.revokeObjectURL(imageFile.preview);
        }
    }, [imageFile]);

    const handleOnDrop = (newFile, setFieldValue) => {
        if (!newFile.length) return;
        const imageFile = {
            file: newFile[0],
            name: newFile[0].name,
            preview: URL.createObjectURL(newFile[0]),
            size: newFile[0].size,

        }
        setImageFile(imageFile);
        setFieldValue(field.name, imageFile)
    }

    return (
        <div className="w-full">
            <DropZone
                // accept=".vtt"

                onDrop={(file) => handleOnDrop(file, form.setFieldValue)}
                multiple={false}
            >
                {({getRootProps, getInputProps}) => (
                    <div {...getRootProps()}
                         className="flex my-5 w-full border-dotted border-4 border-violet-300 rounded-lg shadow-md flex-col h-52 items-center justify-center">
                        {imageFile ? (

                            <div className="w-full flex flex-col items-center justify-center content-center">
                                <input {...getInputProps()} />

                                {/* <img className="h-32 pt-5" src={imageFile.preview} alt={imageFile.name} /> */}

                                <p className="w-full text-center h-20 text-blue-500 pt-5">
                                    {imageFile.name} - {(imageFile.size / 1024000).toFixed(2)}MB
                                </p>
                            </div>

                        ) : (
                            <>
                                <input {...getInputProps()} />
                                <span className="fas fa-4x fa-upload text-violet-600"/>
                                <p style={{color: "#fff"}} className="mt-5">
                                    برای آپلود روی این قسمت کلیک کنید یا فایل مورد نظر را وارد نمایید
                                </p>
                            </>
                        )}
                    </div>)
                }

            </DropZone>
            <span className="text-xs text-red-400">

      {form.errors[props.field.name]}
      </span>
        </div>
    )
}

export default DropZoneField
